exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\r\n  overflow: hidden;\r\n}\r\n\r\n.fader {\r\n  position: fixed;\r\n  background-color: #4e4e4e;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 10;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/home-page.component.css
// module id = ../../../../../src/app/homepage/home-page.component.css
// module chunks = 0